module.exports = __webpack_public_path__ + "img/oldlogo1.b606102c.png";